import { Component, OnInit, OnDestroy, ElementRef, ViewChild, Input } from '@angular/core';
import { Store } from '@ngrx/store';
import { OrderService, AuthenticationService, ShipmentService } from '../../../services';

import {  COMMENT } from '../../../../ngrx/status-types';
import {  SET_ORDER_DETAILS_VIEW, SET_JOB_DETAILS_VIEW, SET_SHIPMENT_DETAILS_VIEW } from '../../../../ngrx/actions';
import { BsModalService } from 'ngx-bootstrap';
import { TranslateService } from 'app/i18n';
import { ActivityHistory } from 'app/models';

@Component({
  selector: 'comment-modal',
  templateUrl: 'comment-modal.component.html'
})
export class CommentModal implements OnInit, OnDestroy {
  @ViewChild('textInput') textInput: ElementRef;
  @Input('order') order;
  @Input('jobs') jobs;
  @Input('job') job;
  @Input('shipment') shipment;
  comment                : string;
  constructor(
    private authService      : AuthenticationService,
    private orderService     : OrderService,
    private store            : Store<any>,
    private translate        : TranslateService,
    private modalService     : BsModalService,
    private shipmentService  : ShipmentService
  ) {
  }
  ngAfterViewInit() {
    console.log(this.modalService.getModalsCount())
    setTimeout(() => this.textInput.nativeElement.focus());
  }
  
  ngOnInit(): void {
    console.log("THIS.ORDER: ",this.order);
    console.log("THIS.JOBS: ",this.jobs);
    console.log("THIS.shipment: ",this.shipment);
    console.log("comment Modal open");
  }

  ngOnDestroy(): void {
    // this.initSubscriptions.forEach(subscription => subscription.unsubscribe());
    // !!this.cancelOrderModalRef && this.cancelOrderModalRef.hide();
    // !!this.changeHoldReasonModalRef && this.changeHoldReasonModalRef.hide();
    // !!this.customerDetailsModalRef && this.customerDetailsModalRef.hide();
    // !!this.onHoldModalRef && this.onHoldModalRef.hide();
    // !!this.reprintModalRef && this.reprintModalRef.hide();
  }

  addComment(): void {
    // !!this.commentModalRef && this.commentModalRef.hide();
    this.modalService.hide(1);

    if(this.jobs && !this.shipment) {
      this.store.dispatch({
        type: SET_ORDER_DETAILS_VIEW,
        payload: { loading: true }
      });
  
      this.orderService.updateFullOrderStatus(
        this.order,
        this.jobs,
        COMMENT,
        this.comment,
      )
    } else if (this.job && !this.shipment) {
      this.store.dispatch({
        type: SET_JOB_DETAILS_VIEW,
        payload: { loading: true }
      });
      this.orderService.setJobStatus(
        this.job,
        COMMENT,
        this.comment,
        undefined,
        undefined
      );
    } else if(!this.job && this.shipment) {
      this.store.dispatch({
        type: SET_SHIPMENT_DETAILS_VIEW,
        payload: { loading: true }
      });
      const now = (new Date).getTime();
      const activity: ActivityHistory = {
        activity  : COMMENT,
        note      : this.comment,
        user      : this.authService.getCurrentUser(),
        timestamp : now.toString(),
        comment   : null,
      };
      if(this.shipment.activity_history && Array.isArray(this.shipment.activity_history)) {
        this.shipment.activity_history.unshift(activity);
      } else {
        this.shipment.activity_history = [activity]
      }
      this.shipmentService.updateShipment(this.shipment);
    }

    this.comment = null;
  }

}



// WEBPACK FOOTER //
// /Users/jlam2/impresocloud/www/client/src/app/shared/modals/comment-modal/comment-modal.component.ts